// extracted by mini-css-extract-plugin
export default {"diagram":"DiagramTab_diagram__po6mX"};